import { Component, OnInit, Renderer2, ChangeDetectorRef, NgZone,AfterViewInit, ViewChild, ElementRef, HostListener, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { AspProductDetailsService } from '../../auto-spare-parts/asp-product-details/asp-product-details.service';
import { ActivatedRoute, NavigationEnd } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AspPrductCompatibilityPopupComponent } from '../asp-prduct-compatibility-popup/asp-prduct-compatibility-popup.component';
import { ToastrService } from 'ngx-toastr';
import {MatTabsModule} from '@angular/material/tabs';
import { AspPlannedInventoryPopupComponent } from '../asp-planned-inventory-popup/asp-planned-inventory-popup.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { AspPrductBottomsheetComponent } from '../asp-prduct-bottomsheet/asp-prduct-bottomsheet.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AspCartService } from 'app/main/auto-spare-parts/asp-cart/asp-cart.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { filter } from 'rxjs/operators';
import { AspLoadingService } from '../asp-loading/asp-loading.service';
import { AspInstantRequestComponent } from '../asp-instant-request/asp-instant-request.component';
import { AspReplaceWishlistPopupComponent } from '../asp-replace-wishlist-popup/asp-replace-wishlist-popup.component';

@Component({
  selector: 'app-asp-product-details',
  templateUrl: './asp-product-details.component.html',
  styleUrls: ['./asp-product-details.component.scss'],
  // standalone: true,
  // imports: [MatTabsModule],
})


export class AspProductDetailsComponent implements OnInit,AfterViewInit {
  id: string;
  activeTab: string = 'data.description';
  type: string;
  lotsOfTabs = new Array(30).fill(0).map((_, index) => `Tab ${index}`);
  whenIsItNeeded: any = '';
  key: string = '';
  isShowOnce: number = 0;
  offer:any='';
  faqs: any[] = [];
  TopQuality:any='';
  addedCart:any=[];
  newData:any={};
  items: any[] = []; 
  counts: number = 0;
  data: any='';
  vehicleType:any = localStorage.getItem('vehicleType');
  cartCount = 0;
  cartSubTotal = 0;
  cartGrandTotal = 0; 
  cartList = [];
  isCartCount:boolean = false;
  vehicle: any;
  emptyList: any = 'assets/images/no-cart.png';
  showEmptyState: boolean = false;
  selectedModel: string = '';
  selectedYear: number;
  variants: any = {};
  getSelectedVariants: any[] = [];
  fuelList: number[] = [];
  getSelectedYears: any[] = [];
  VariantsList: string[] = [];
  fuelType: string[] = [];
  getSelectedTitles: string[] = [];
  getSelectedFuel: any;
  selectedCompatibleYear: number;
  compatability:any[] = [];
  showAllMap: { [key: string]: boolean } = {};
  isCompatibilityVisible: boolean = false;
  activeVehicle: any = null;
  discountType: string;
  showPopup = false;
  assignedWarehouseName : any;
  assignedWarehouseStock = 0;
  selectedImage: string = '';

// @ViewChild('thumbnailContainer') thumbnailContainer: ElementRef;
  @ViewChild('thumbnailContainer') thumbnailContainer!: ElementRef;
  @ViewChild('addButton',{ static: false }) addButton: ElementRef;
  // @ViewChild('compatibilitySection') compatibilitySection!: ElementRef;
  @ViewChild('compatabilityDiv') compatabilityDiv: ElementRef;
  // @ViewChild('recomanded', { static: false }) recomanded!: ElementRef;

  @ViewChild('secondDiv', { static: false }) secondDiv!: ElementRef;
  @ViewChild('scrollContainer', { static: true }) scrollContainer!: ElementRef;
  @ViewChild('intstantorder', { read: ViewContainerRef }) instantOrderContainer!: ViewContainerRef;
  // @ViewChild('compatabilityDiv', { static: false }) compatabilityDiv: ElementRef;

  showBottomDiv = false;
  showCartDiv: boolean= false;
  topAddToCartButton: any;
  plannedSku: void;
  hasOpened: boolean = false;
  dataplannedSku: any;
  previouslyBought: any;
  orderedCount: any;
  garageCount: any;
  vehicles: any[] = [];
  loading: boolean = true;
  mrp: any;
  mrps: any;
  selling: any;
  minMrp: number;
  isMobile: boolean;
  shippingChargesApplicable: any;
  shippingCharges: any;
  avoidShippingCharges: any;
  grandAmount: any;
  sparesDiscount: number;
  openIndex: number;
  showLeftArrow = false;
  showRightArrow = false;
  isAvailable: boolean = false;
  addedWishlist: any = [];
  wishlistList: any = [];
  wishlistCount = 0;
  insurance: any[] = [];
  isInsurance: boolean = false;

  selectTab(tab: string): void {
    this.activeTab = tab;
  }

  constructor
  (
    private aspProductDetailsService: AspProductDetailsService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private zone: NgZone,
    private toastr: ToastrService,
    private renderer: Renderer2,
    private bottomSheet: MatBottomSheet,
    private breakpointObserver: BreakpointObserver,
    private aspCartService: AspCartService,
    private router: Router,
    private location: Location,
    private cdr: ChangeDetectorRef,
    private aspLoadingService: AspLoadingService,
    private resolver: ComponentFactoryResolver
  ) {
      this.breakpointObserver.observe([Breakpoints.Handset])
    .subscribe(result => {
      this.isMobile = result.matches;
    }); }
  
  

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.type = params.get('type');
      this.id = params.get('id');
    });

     if (this.type === 'kit') {
      this.getKitDetails();
    } else {
      this.getProductDetails();
    }
    this.getCart();
    this.getWishlist();  
    // Detect route changes
    // this.router.events
    // .pipe(filter(event => event instanceof NavigationEnd))
    // .subscribe((event: NavigationEnd) => {
    //   console.log('Current route:', event.url);

    
    // (document.getElementsByClassName('mat-icon notranslate toolbar-hamburger-menu material-icons mat-icon-no-color')[0] as HTMLInputElement).innerHTML = '';
    // (document.getElementsByClassName('material-icons-arrowback-new')[0] as HTMLInputElement).innerHTML = 'arrow_back';
    // (document.getElementsByClassName('mat-icon notranslate garage-icon-mobile-view material-icons mat-icon-no-color')[0] as HTMLInputElement).innerHTML = '';
    // (document.getElementsByClassName('mywalletbtn')[0] as HTMLInputElement).innerHTML = '';
    // (document.getElementsByClassName('logo-icon')[0] as HTMLInputElement).innerHTML = '';

    // });
    // ✅ refresh wishlist buttons/stepper when wishlist changes anywhere in the app
     window.addEventListener('wishlistUpdated', () => {
      this.getWishlist();
      this.cdr.detectChanges();
    });
   
  }
  
  public initialize() {
    this.getCart();
  }

  ngAfterViewInit() {
    if (!this.compatabilityDiv) {
      console.error('secondDiv was not initialized.');
    }
     setTimeout(() => {
    this.updateArrowVisibility();
  });
    
  }
 

  // checkButtonPosition() {
  //   const rect = this.addButton.nativeElement.getBoundingClientRect();
  //   this.showCartDiv = rect.top <= 0;
  //    
  // }

  // @HostListener('window:scroll', [])
  // onWindowScroll() {
  //   this.checkButtonPosition();
  // }

  // checkButtonHeight() {
  //   const buttonHeight = this.topAddToCartButton.nativeElement.getBoundingClientRect().top;
  //   console.log('Button Height:', buttonHeight); 
  //   this.showCartDiv = buttonHeight < 0;
  //   console.log('Show Cart Div:', this.showCartDiv); 
  // }

 
  getCompatability(partNumber: string) {
    this.aspLoadingService.show();
    this.aspProductDetailsService.getProductCompatability(partNumber).subscribe(result => {
      let res = JSON.parse(JSON.stringify(result));
      // console.log(res)
      this.aspLoadingService.hide();
      this.compatability = [];  // Initialize as an empty array
      res['data']?.vehicle?.forEach(vehicle => {
        let data = [];
        

        vehicle.models.forEach(model => {
          let rowKey = model.rowKey;
          let modelName = model.model;
          res['data']['variants'][rowKey]?.forEach(list => {
            list.model = modelName;
            data.push(list);
          });
        });
        this.compatability.push([vehicle.name, data]);

        // Initialize showAllMap for each vehicle
        this.showAllMap[vehicle.name] = false;
        this.vehicles=vehicle.models.length;
      });
      

      // console.log("compatability data: ",this.compatability);
    });
  }

  getVisibleModels(models: any[], vehicleName: string): any[] {
    return this.showAllMap[vehicleName] ? models : models.slice(0, 10);
  }

  toggleShowMore(vehicleName: string) {
    this.showAllMap[vehicleName] = !this.showAllMap[vehicleName];
  }
  toggleCompatibility(): void {
    this.isCompatibilityVisible = true;
  }

  scrollToCompatibility() {
    // const offsetTop = this.compatabilityDiv.nativeElement.offsetTop;
    // window.scrollTo({ top: offsetTop, behavior: 'smooth' }); 
    this.compatabilityDiv.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' }); 
  }
  // scrollToRecomanded() {
  //   this.recomanded.nativeElement.scrollIntoView({
  //     behavior: 'smooth',  
  //     block: 'start'});
    
  // }
  // Method to set the active vehicle for the compatibility tab
  setActiveVehicle(vehicle: any): void {
    this.activeVehicle = vehicle;
  }

 

  getAllCatPopup = () => {
    this.zone.run(() => {
      const dialogRef =this.dialog.open(AspPrductCompatibilityPopupComponent);
      dialogRef.afterOpened().subscribe(() => {
        const componentInstance = dialogRef.componentInstance;
        // componentInstance.getProductCompatability(this.partNumber);
      });
    });
  }
  getProductDetails() {
    let garageKey = localStorage.getItem('garageKey');
    this.aspLoadingService.show();
    this.aspProductDetailsService.productDetails(garageKey, this.type,this.id).subscribe(
      result => {
            this.aspLoadingService.hide();
        let res = JSON.parse(JSON.stringify(result)); 
        if(res.code === 200){ 
          this.data = res.data;    
          if (!this.data.imageUrls || !Array.isArray(this.data.imageUrls)) {
            this.data.imageUrls = [];
          }

          if (this.data.imageUrl && !this.data.imageUrls.includes(this.data.imageUrl)) {
            this.data.imageUrls.unshift(this.data.imageUrl);
          }

          this.selectedImage = this.data.imageUrls[0];      
          this.whenIsItNeeded = JSON.parse(this.data.whenIsItNeeded);
          this.dataplannedSku=res.data.plannedSku;
          const sellingPrices = [];
          this.mrps = res?.data?.alternate?.forEach(alternates => {
            this.selling = alternates.sellingPrice;
            // console.log("this.selling", this.selling);
            sellingPrices.push(this.selling);
          });
          this.minMrp = Math.min(...sellingPrices);
          // console.log("this.minMrp", this.minMrp);

        const itemSummary = res?.data?.itemSummary && res?.data?.itemSummary?.length > 0 ? res?.data?.itemSummary[0] : null;
        
          this.previouslyBought = itemSummary?.previouslyBought;
          this.orderedCount = itemSummary?.orderedCount;
          this.garageCount = itemSummary?.garageCount;
  
          if (this.data.mrp > 0) {
            this.discountType = ((this.data.discount / this.data.mrp) * 100).toFixed(0) + '%';
          } 
          
          this.getCompatability(res.data.partNumber);
          
          
        this.setAssignedWarehouseStock();
        // this.computeAvailability();
        this.computeAvailability(res.data.isAvailable); 
        } 
        else {
          // this.loading = false;
          this.toastr.error(result['data']['description'], 'Item Details');
        }
      }
    );
  }

  addCart(count){
    // this.scrollToRecomanded();
    let preferredWarehouse: any = '';
    let availableStock: number = 0;
    // if (this.data?.alternate?.length !==0 && this.data?.alternate !==null && !this.hasOpened && this.loading==false) {
    //   this.hasOpened = true;  // Mark as opened
    //   const bottomSheetRef = this.bottomSheet.open(AspPrductBottomsheetComponent, {
    //     data: { id: this.data.partNumber},

    //     panelClass: 'custom-bottom'
    //   });
  
    //   // Reset the flag when the bottom sheet is dismissed
    //   bottomSheetRef.afterDismissed().subscribe(() => {
    //     this.hasOpened = false;  // Reset flag after closing
    //   });
    // }
    // else 
    // if(this.data?.alternate?.length >= 0 || this.data?.alternate ==null || this.hasOpened) {
      // if(this.data.plannedSku==1){
        // this.data.warehouseData.forEach(warehouse => {
        //   if(warehouse.preferred==true){
        //     preferredWarehouse = warehouse.name;
        //   }
        // });

        // if(preferredWarehouse){
        //   this.data.warehouseStock.forEach(stock => {
        //     if(stock.name.toLowerCase().includes(preferredWarehouse.toLowerCase())){
        //       availableStock = stock.stock;
        //     }
        //   });

        //   if(count > availableStock){
        //     this.openPlannedSkuPopup(availableStock, count, this.data.plannedSku);
        //   }else{
        //     this.addItemToCart(count);
        //   }
        // }      
      // }
      // else{
        // if(count > availableStock && this.isShowOnce==0){
        //   this.isShowOnce = 1;
        //   // this.openPlannedSkuPopup(availableStock, count, this.data.plannedSku);
        // }
        // else{
          this.addItemToCart(count);
        // }
      // }
    // }
  
    // this.addItemToCart(count);
  }

  addItemToCart(count){      
    this.addedCart = [];
    if(this.vehicleType=='universal'){
      this.data.type = 'universal';
    }
    if(localStorage.getItem('addedCart')){
      this.newData = JSON.parse(localStorage.getItem('addedCart'))[0];
      this.data.cart_qty = count;
      
      delete this.data.rowKey;
      delete this.data.variantKey;
      let make = localStorage.getItem('selectedMake');
      let model = localStorage.getItem('selectedModel');
      let registrationNumber = localStorage.getItem('registrationNumber');
      let variant = localStorage.getItem('variant');
      let mfgYear = localStorage.getItem('selectedYear');
      let fuelType = localStorage.getItem('selectedFuel');
      let rowKey = localStorage.getItem('rowKey');
      let variantKey = localStorage.getItem('variantKey');
      this.data = {
        ... this.data, 
        selectedMake: make,
        selectedModel: model,
        registrationNumber: registrationNumber,
        variant: variant,
        selectedYear: mfgYear,
        selectedFuel: fuelType, 
        rowKey: rowKey, 
        variantKey: variantKey      
      };
      this.newData[this.data.key] = this.data;
      this.addedCart.push(this.newData);
      localStorage.setItem('addedCart', JSON.stringify(this.addedCart));
      window.dispatchEvent(new Event('cartUpdated'));
    }else{
      this.data.cart_qty = count;
      delete this.data.rowKey;
      delete this.data.variantKey;
      let make = localStorage.getItem('selectedMake');
      let model = localStorage.getItem('selectedModel');
      let registrationNumber = localStorage.getItem('registrationNumber');
      let variant = localStorage.getItem('variant');
      let mfgYear = localStorage.getItem('selectedYear');
      let fuelType = localStorage.getItem('selectedFuel');
      let rowKey = localStorage.getItem('rowKey');
      let variantKey = localStorage.getItem('variantKey');
      this.data = {
        ... this.data, 
        selectedMake: make,
        selectedModel: model,
        registrationNumber: registrationNumber,
        variant: variant,
        selectedYear: mfgYear,
        selectedFuel: fuelType, 
        rowKey: rowKey, 
        variantKey: variantKey      
      };
      this.newData[this.data.key] = this.data;
      this.addedCart.push(this.newData);
    //  console.log(this.addedCart);
      localStorage.setItem('addedCart', JSON.stringify(this.addedCart));
      window.dispatchEvent(new Event('cartUpdated'));
    }      
    this.getCart();
  }


  openPlannedSkuPopup(availableStock, count, plannedSku){
    const dialogRef = this.dialog.open(AspPlannedInventoryPopupComponent, {
      "data":{
        "itemDetails": this.data,
        "plannedSku": plannedSku,
        "availableStock": availableStock,
        "count": count
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getProductDetails();
      this.getCart();      
    });
  }

  
  getCart(){
    let cartData;  
    this.cartList = [];
    this.cartCount = 0;
    this.cartSubTotal = 0;
    this.cartGrandTotal = 0;
     if(localStorage.getItem('addedCart')){   
      cartData = JSON.parse(localStorage.getItem('addedCart'));
      if(Object.keys(cartData[0]).length==0){
        this.isCartCount = false;
      } 

      this.cartCount = 0;      
      Object.values(cartData[0]).forEach(cart => { 
        if(cart){
          this.isCartCount = true;

          this.cartCount++;

     // this.cartCount += cart['cart_qty'];
        if(cart['sellingPrice']>0){
          this.cartSubTotal += (cart['sellingPrice']*cart['cart_qty']);
        }else{
          this.cartSubTotal += (cart['mrp']*cart['cart_qty']);
        }
        this.cartList.push(cart);

      }
      });   

      this.cartList = cartData;
      this.cartGrandTotal = this.cartSubTotal;
      // console.log(this.cartList);
      if(this.sparesDiscount>0){
        this.cartGrandTotal = (this.cartSubTotal - this.sparesDiscount);
    }else{
        this.cartGrandTotal = this.cartSubTotal;
    }
    this.getShippingCharges()
  
    }
  }
  goToCart(){
    this.router.navigate(['cart']);
  }

  removeItem(count, item){ 
    this.addedCart = [];    
    let data;
    
    data = JSON.parse(localStorage.getItem('addedCart'))[0];
    if(count>1){
      let countval = count-1;
      data[item].cart_qty = countval;

      if(this.vehicleType=='universal'){
        data[item].type = 'universal';
      }

      this.addedCart[0] = data;
      localStorage.setItem('addedCart', JSON.stringify(this.addedCart));
      window.dispatchEvent(new Event('cartUpdated'));
      this.getCart();
    }else{
      if(this.isShowOnce = 1){
        this.isShowOnce = 0;
      }
      this.deleteItem(item);
      this.toastr.error(data[item].name+' removed from cart', 'Cart Item');
    }
  }

  deleteItem(item){
    this.newData = {};
    let cartData;

    cartData = JSON.parse(localStorage.getItem('addedCart'));
    Object.values(cartData[0]).forEach(cart => { 
      if(cart['key']!=item) {
        this.newData[cart['key']] = cart;
      }
    });
    
    this.addedCart[0] = this.newData;
    localStorage.setItem('addedCart', JSON.stringify(this.addedCart));
    window.dispatchEvent(new Event('cartUpdated'));
    this.getCart();
    // console.log(this.addedCart);
    
  }

  addItem(count){
    let countval = count+1;
    this.addCart(countval);
    // this.addedCart = [];
    // let data;
    
    // data = JSON.parse(localStorage.getItem('addedCart'))[0];
    // if(countval<=data[item].spareStocks.quantity){
    //   data[item].cart_qty = countval;

    //   if(this.vehicleType=='universal'){
    //     data[item].type = 'universal';
    //   }

    //   this.addedCart[0] = data;
    //   localStorage.setItem('addedCart', JSON.stringify(this.addedCart));
    //   this.getCart();
    // }else{
    //   this.toastr.error('Only '+data[item].spareStocks.quantity+' unit available for this item', 'Error');
    // }
  }
  
  
  
  saveMore(){
    if (this.data?.alternate?.length !==0 && this.data?.alternate !==null) {
      this.hasOpened = true;
      const bottomSheetRef = this.bottomSheet.open(AspPrductBottomsheetComponent, {
        data: { id: this.data.partNumber},

        panelClass: 'custom-bottom'
      });
  
      // Reset the flag when the bottom sheet is dismissed
      bottomSheetRef.afterDismissed().subscribe(() => {
        this.hasOpened = false;  // Reset flag after closing
      });
    }
  }
  getShippingCharges(){    
    // this.loading = true; 
    let garageKey = localStorage.getItem('garageKey');
    this.aspCartService.getShippingCharges(this.cartGrandTotal, garageKey).subscribe(
      result => {
        let res = JSON.parse(JSON.stringify(result)); 
        if(res.code==200){
          this.shippingChargesApplicable = res.data.shippingChargesApplicable;
          this.shippingCharges = res.data.shippingCharges;
          this.avoidShippingCharges = res.data.avoidShippingCharges;
          this.grandAmount= res.data.cartValue;
          this.aspLoadingService.hide();
            this.cartGrandTotal = this.grandAmount+this.shippingCharges;

            if(!this.isMobile){
              if(this.cartCount>0){
                (document.getElementsByClassName('cart_count_num')[0] as HTMLInputElement).innerHTML = ''+this.cartCount+' items <div class="right-amount-carts">₹'+this.cartGrandTotal.toFixed(2)+'</div>';
              }else{
                (document.getElementsByClassName('cart_count_num')[0] as HTMLInputElement).innerHTML = 'My Cart';
              }
            }else{
              if(this.cartCount>0){
                { const cartCountMobileEl = document.getElementsByClassName('cart_count_mobile')[0] as HTMLInputElement; if (cartCountMobileEl) { cartCountMobileEl.innerHTML = '<div class="cart_count">'+this.cartCount+'</div>'; } }
              }else{
                { const cartCountMobileEl = document.getElementsByClassName('cart_count_mobile')[0] as HTMLInputElement; if (cartCountMobileEl) { cartCountMobileEl.innerHTML = ''; } }
              }
            }            
          
        } else {
          if(!this.isMobile){
            if(this.cartCount>0){
              (document.getElementsByClassName('cart_count_num')[0] as HTMLInputElement).innerHTML = ''+this.cartCount+' items <div class="right-amount-carts">₹'+this.cartGrandTotal.toFixed(2)+'</div>';
            }else{
              (document.getElementsByClassName('cart_count_num')[0] as HTMLInputElement).innerHTML = 'My Cart';
            }
          }else{
            if(this.cartCount>0){
              { const cartCountMobileEl = document.getElementsByClassName('cart_count_mobile')[0] as HTMLInputElement; if (cartCountMobileEl) { cartCountMobileEl.innerHTML = '<div class="cart_count">'+this.cartCount+'</div>'; } }
            }else{
              { const cartCountMobileEl = document.getElementsByClassName('cart_count_mobile')[0] as HTMLInputElement; if (cartCountMobileEl) { cartCountMobileEl.innerHTML = ''; } }
            }
          }
        }
      }
    );
  }
  goBack(): void {
    this.location.back();
  }
  @HostListener('window:scroll', [])
  onScroll() {
    if (!this.secondDiv || !this.secondDiv.nativeElement) {
      console.warn('secondDiv not initialized yet.');
      return;
    }
  
    const rect = this.secondDiv.nativeElement.getBoundingClientRect();
    this.showBottomDiv = rect.top <= 0;
    // console.log('secondDiv position:', rect.top);
    const container = document.querySelector('.scroll-container');
  // container.scrollTop = container.scrollHeight;
  }

setAssignedWarehouseStock() {
  this.assignedWarehouseName = localStorage.getItem("zone") || '';
  let foundStock = null;

  for (let w of this.data.warehouseStock) {

    if (w.name.trim() === this.assignedWarehouseName.trim()) {
      foundStock = w.stock;
      break;
    }
  }
  
    // console.log("✅ FINAL assignedWarehouseStock =1", this.assignedWarehouseStock);
  this.assignedWarehouseStock = foundStock !== null ? foundStock : 0;
  
    // console.log("✅ FINAL assignedWarehouseStock =2", this.assignedWarehouseStock);

}



  hasStockInAssigned = false;
  hasStockInOther = false;
  noStockAnywhere = false;

  openPopup() {
    this.showPopup = true;
    this.evaluateStock();
  }

  closePopup() {
    this.showPopup = false;
  }

  evaluateStock() {
    this.hasStockInAssigned = this.assignedWarehouseStock > 0;
    
    // console.log("✅ FINAL assignedWarehouseStock =3", this.assignedWarehouseStock);
    this.hasStockInOther = this.data.warehouseStock.some(w => w.stock > 0);
    this.noStockAnywhere = !this.hasStockInAssigned && !this.hasStockInOther;
  }
    toggleFAQ(index: number) {
    this.openIndex = this.openIndex === index ? null : index;
  }

  onThumbnailScroll() {
    this.updateArrowVisibility();
  }

  updateArrowVisibility() {
    const el = this.thumbnailContainer.nativeElement;

    this.showLeftArrow = el.scrollLeft > 0;

    this.showRightArrow =
      el.scrollLeft + el.clientWidth < el.scrollWidth;
  }

  scrollThumbnails(direction: 'left' | 'right') {
    const el = this.thumbnailContainer.nativeElement;
    const scrollAmount = 120;

    if (direction === 'left') {
      el.scrollLeft -= scrollAmount;
    } else {
      el.scrollLeft += scrollAmount;
    }

    // Update arrows after scroll
    setTimeout(() => this.updateArrowVisibility(), 150);
  }
  // getKitDetails() {
    
  //   const garageKey = localStorage.getItem('garageKey');
  //   const rowKey = localStorage.getItem('rowKey');
  //   const variantKey = localStorage.getItem('variantKey');
  //   const registrationNumber = localStorage.getItem('registrationNumber');

  //   if (!garageKey) {
  //     console.error("garageKey missing in localStorage");
  //     return;
  //   }

  //   let payload: any;

  //   // 🔵 If coming from decode
  //   if (this.id === 'decode') {
      
  //     if (!rowKey || !variantKey) {
  //       console.error("rowKey or variantKey missing");
  //       return;
  //     }

  //     payload = {
  //       decode: true,
  //       garageKey: garageKey,
  //       registrationNumber: registrationNumber,
  //       rowKey: rowKey,
  //       variantKey: variantKey
  //     };

  //   }
  //   // 🔵 Normal kit flow
  //   else {

  //     payload = {
  //       garageKey: garageKey,
  //       kitKey: this.id,
  //       source: "web"
  //     };

  //   }

  //   console.log("KIT PAYLOAD:", payload);

  //   this.aspLoadingService.show();

  //   this.aspProductDetailsService.kitDetails(payload).subscribe(
  //     result => {

  //       this.aspLoadingService.hide();

  //       let res = JSON.parse(JSON.stringify(result));

  //       if (res.code === 200) {

  //         // 🔥 Normalize kit response
  //         this.data = this.mapKitToProductFormat(res.data);

  //         if (!this.data.imageUrls || !Array.isArray(this.data.imageUrls)) {
  //           this.data.imageUrls = [];
  //         }

  //         this.selectedImage = '../../../../assets/images/service-kit-img/ser-kit-prd-dtl-img.jpeg';

  //         this.discountType = this.data.mrp > 0
  //           ? ((this.data.discount / this.data.mrp) * 100).toFixed(0) + '%'
  //           : null;

  //       } 
  //       else if (res.code === 908) {

  //         this.showEmptyState = true;
  //         this.data = null;   // important
  //       }

  //       else {
  //         this.toastr.error(res?.data?.description, 'Kit Details');
  //       }

  //     },
  //     error => {
  //       this.aspLoadingService.hide();
  //       console.error("KIT ERROR FULL:", error);
  //     }
  //   );

  // }
  getKitDetails() {

  const garageKey = localStorage.getItem('garageKey');
  const rowKey = localStorage.getItem('rowKey');
  const variantKey = localStorage.getItem('variantKey');
  const registrationNumber = localStorage.getItem('registrationNumber');

  if (!garageKey) {
    console.error("garageKey missing in localStorage");
    return;
  }

  // ✅ Reset states before API call
  this.loading = true;
  this.showEmptyState = false;
  this.data = null;

  let payload: any;

  if (this.id === 'decode') {

    if (!rowKey || !variantKey) {
      console.error("rowKey or variantKey missing");
      return;
    }

    payload = {
      decode: true,
      garageKey: garageKey,
      registrationNumber: registrationNumber,
      rowKey: rowKey,
      variantKey: variantKey
    };

  } else {

    payload = {
      garageKey: garageKey,
      kitKey: this.id,
      source: "web"
    };
  }

  this.aspLoadingService.show();

  this.aspProductDetailsService.kitDetails(payload).subscribe(
     (result: any) => {

      this.aspLoadingService.hide();
      this.loading = false;

      const res = result;

      // ✅ SUCCESS
      if (res.code === 200) {

        this.showEmptyState = false;

        this.data = this.mapKitToProductFormat(res.data);

        if (!this.data.imageUrls || !Array.isArray(this.data.imageUrls)) {
          this.data.imageUrls = [];
        }

        this.selectedImage =
          '../../../../assets/images/service-kit-img/ser-kit-prd-dtl-img.jpeg';

        this.discountType = this.data.mrp > 0
          ? ((this.data.discount / this.data.mrp) * 100).toFixed(0) + '%'
          : null;
      }

      // ✅ 908 EMPTY STATE
      else if (res.code === 908) {

        this.showEmptyState = true;
        this.data = null;
      }

      // ❌ Other Errors
      else {
        this.showEmptyState = false;
        this.toastr.error(res?.data?.description || 'Something went wrong', 'Kit Details');
      }
    },
    error => {

      this.aspLoadingService.hide();
      this.loading = false;
      this.showEmptyState = true; // optional fallback
      console.error("KIT ERROR FULL:", error);
    }
  );
}


  private mapKitToProductFormat(kit: any) {

    return {
      key: kit.id?.toString() || null,
      name: kit.name,
      partNumber: null,
      rowKey: localStorage.getItem('rowKey'),
      variantKey: localStorage.getItem('variantKey'),
      description: kit.description,
      partType: 'KIT',
      category: 'Service Kit',
      subCategory: null,
      imageUrl: null,
      imageUrls: [],

      count: 0,
      mrp: kit.mrp,
      costPrice: kit.costPrice,
      // sellingPrice: kit.mrp - kit.discount,
      sellingPrice: kit.costPrice ,
      discount: kit.discount,
      discountType: kit.discountType,

      brand: {
        key: null,
        name: 'Service Kit',
        description: null,
        imageUrl: null,
        priority: 0,
        skuCount: 0,
        type: null
      },

      tag: '',
      deliveryTime: '',
      deliveryStatus: '',
      unit: 0,
      unitType: '',

      whenIsItNeeded: null,
      faqs: [],

      warehouseData: [],
      warehouseStock: [],
      plannedSku: 0,

      itemSummary: [],
      alternate: [],

      hsnCode: null,
      gstRate: null,

      // 🔥 Extra for kit-specific UI if needed
      kitItems: kit.items || []
    };
  }

  getKitLabel(partName: string): string {

  if (!partName) return '';

  const name = partName.toLowerCase();

  if (name.includes('engine oil')) {
    return 'Engine Oil (Universal)';
  }

  if (name.includes('air filter')) {
    return 'Air Filter';
  }

  if (name.includes('oil filter')) {
    return 'Oil Filter';
  }

  if (name.includes('coolant')) {
    return 'Coolant (Universal)';
  }

  if (name.includes('brake')) {
    return 'Brake Oil (Universal)';
  }

  return partName;
}
goToVariantList(){
  localStorage.setItem("kitFlow", "1")
  this.router.navigate(['variant']);
}
// ========================================NEW TASK=====================================================
computeAvailability(apiIsAvailable?: boolean) {
  this.evaluateStock(); // still sets hasStockInAssigned / hasStockInOther — used for the popup breakdown UI

  if (apiIsAvailable !== undefined && apiIsAvailable !== null) {
    // Trust backend as source of truth
    this.isAvailable = apiIsAvailable;
  } else {
    // Fallback for kit flow / older API responses without the field
    // TODO: once preferred-vendor API exists, OR that result in here too
    this.isAvailable = this.hasStockInAssigned || this.hasStockInOther;
  }
}

// Stub — wire to real wishlist API once backend contract is ready
// Replace the old stub addToRequestWishlist() with this
addToRequestWishlist(items = this.data) {
  // ===== guard — if car details aren't in localStorage, open instant-request sidebar instead =====
  const vehicleData = localStorage.getItem('vehicleData');
  const registrationNumber = localStorage.getItem('registrationNumber');

  if (!vehicleData || !registrationNumber) {
    localStorage.setItem('reqWishlistFlow', '1');
    localStorage.setItem('pendingWishlistItem', JSON.stringify(items));
    this.loadInstantDetails();
    return;
  }
  // ===== END guard =====

  // ===== NEW: check if wishlist already has items for a DIFFERENT car =====
  if (localStorage.getItem('addedWishlist')) {
    const existingData = JSON.parse(localStorage.getItem('addedWishlist'))[0] || {};
    const existingKeys = Object.keys(existingData);

    if (existingKeys.length > 0) {
      const firstExistingItem = existingData[existingKeys[0]];
      const existingRegNo = firstExistingItem?.registrationNumber;
      const currentRegNo = registrationNumber;
      const normalize = (regNo: string) => (regNo || '').replace(/[\s"]/g, '').toUpperCase();
       if (existingRegNo && normalize(existingRegNo) !== normalize(currentRegNo))  {
        const dialogRef = this.dialog.open(AspReplaceWishlistPopupComponent, {
          panelClass: 'wishlist-switch-dialog-panel',
          data: {
            currentCarLabel: existingRegNo,
            newCarLabel: currentRegNo,
            currentWishlistItems: existingKeys.length,
            pendingItemName: items?.name || ''
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result?.action === 'replace') {
            localStorage.removeItem('addedWishlist');
            this.addItemToWishlist(items);
            // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            //   this.router.navigate(['request-wishlist']);
            // });
          } else if (result?.action === 'keep') {
            // leave existing wishlist untouched, current item is NOT added
            // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            //   this.router.navigate(['request-wishlist']);
            // });
          }
          // else: dialog was dismissed (backdrop click, Escape, close icon) with no result/action —
          // do nothing at all, stay on the current page
        });

        return;
      }
    }
  }
  // ===== END NEW =====

  this.addItemToWishlist(items);
}

private addItemToWishlist(items) {
  // work on a copy so we don't mutate this.data's rowKey/variantKey used elsewhere on the page
  const itemToSave = { ...items };
  delete itemToSave.rowKey;
  delete itemToSave.variantKey;

  this.addedWishlist = [];
  if (this.vehicleType == 'universal') {
    itemToSave.type = 'universal';
  }

  this.newData = localStorage.getItem('addedWishlist')
    ? JSON.parse(localStorage.getItem('addedWishlist'))[0]
    : {};

  itemToSave.cart_qty = 1;
  const make = localStorage.getItem('selectedMake');
  const model = localStorage.getItem('selectedModel');
  const regNo = localStorage.getItem('registrationNumber');
  const variant = localStorage.getItem('variant');
  const mfgYear = localStorage.getItem('selectedYear');
  const fuelType = localStorage.getItem('selectedFuel');
  const rowKey = localStorage.getItem('rowKey');
  const variantKey = localStorage.getItem('variantKey');

  const finalItem = {
    ...itemToSave,
    ...itemToSave.spareStocks,
    selectedMake: make,
    selectedModel: model,
    registrationNumber: regNo,
    variant: variant,
    selectedYear: mfgYear,
    selectedFuel: fuelType,
    rowKey: rowKey,
    variantKey: variantKey
  };

  finalItem.discount = finalItem.discountAmount;
  delete finalItem.discountAmount;

  this.newData[finalItem.key] = finalItem;
  this.addedWishlist.push(this.newData);
  localStorage.setItem('addedWishlist', JSON.stringify(this.addedWishlist));

  this.getWishlist();
  window.dispatchEvent(new Event('wishlistUpdated'));
}

getWishlist() {
  let wishlistData;
  this.wishlistList = [];
  this.wishlistCount = 0;

  if (localStorage.getItem('addedWishlist')) {
    wishlistData = JSON.parse(localStorage.getItem('addedWishlist'));

    Object.values(wishlistData[0]).forEach(item => {
      if (item) {
        this.wishlistCount++;
      }
    });

    this.wishlistList = wishlistData;
  }
}

removeWishlistItem(count, item) {
  this.addedWishlist = [];
  let data = JSON.parse(localStorage.getItem('addedWishlist'))[0];

  if (count > 1) {
    const countval = count - 1;
    data[item].cart_qty = countval;

    if (this.vehicleType == 'universal') {
      data[item].type = 'universal';
    }

    this.addedWishlist[0] = data;
    localStorage.setItem('addedWishlist', JSON.stringify(this.addedWishlist));
    this.getWishlist();
    window.dispatchEvent(new Event('wishlistUpdated')); 
  } else {
    this.deleteWishlistItem(item);
    this.toastr.error(data[item].name + ' removed from Request Wishlist', 'Request Wishlist');
  }
}

deleteWishlistItem(item) {
  this.newData = {};
  const wishlistData = JSON.parse(localStorage.getItem('addedWishlist'));

  Object.values(wishlistData[0]).forEach(w => {
    if (w['key'] != item) {
      this.newData[w['key']] = w;
    }
  });

  this.addedWishlist[0] = this.newData;
  localStorage.setItem('addedWishlist', JSON.stringify(this.addedWishlist));
  this.getWishlist();
  window.dispatchEvent(new Event('wishlistUpdated'));
}

addWishlistItem(count, item) {
  const countval = count + 1;
  const data = JSON.parse(localStorage.getItem('addedWishlist'))[0];
  data[item].cart_qty = countval;
  this.addedWishlist[0] = data;
  localStorage.setItem('addedWishlist', JSON.stringify(this.addedWishlist));
  this.getWishlist();
  window.dispatchEvent(new Event('wishlistUpdated'));
}

loadInstantDetails() {
  if (this.insurance.length > 0 && !(localStorage.getItem('instantOrder') == '2')) {
    this.isInsurance = true;
  } else {
    const factory = this.resolver.resolveComponentFactory(AspInstantRequestComponent);
    const componentRef = this.instantOrderContainer.createComponent(factory);
    const componentBInstance = componentRef.instance as AspInstantRequestComponent;

    if (localStorage.getItem('instantOrder') && localStorage.getItem('instantOrder') == '2') {
      componentBInstance.closeDetails(true);
      componentBInstance.openSidebar(true);
    } else {
      componentBInstance.closeDetails(false);
      componentBInstance.openSidebar(true);
      localStorage.removeItem('carNumber');
    }
  }
}



}




